export const MODAL_TYPE = {
    CLOSE: 'CLOSE',
    CARE_ORDER_BABY_INIT_ERROR_BAD_PARAMS_TIME_SLOT_LIST: 'CARE_ORDER_BABY_INIT_ERROR_BAD_PARAMS_TIME_SLOT_LIST',
    CARE_ORDER_BABY_INIT_ERROR_CARE_CLIENT_VISITOR_EXPIRED: 'CARE_ORDER_BABY_INIT_ERROR_CARE_CLIENT_VISITOR_EXPIRED',
};
